module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/LezioneDodiciUnoGEN.db4f47cf.png";